import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getOrElse } from 'src/util/values';

interface AddressDisplayOptions {
  streetAddress?: boolean;
  city?: boolean;
  region?: boolean;
  postalCode?: boolean;
  county?: boolean;
  country?: boolean;
  gpsId?: boolean;
  coordinates?: boolean;
}

const defaultDisplayOptions: AddressDisplayOptions = {
  streetAddress: true,
  city: true,
  region: true,
  postalCode: true,
  county: true,
  country: true,
  coordinates: true,
  gpsId: true,
};

@Component({
  selector: 'tcs-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressComponent {
  @Input()
  public address: any;
  @Input()
  public displayOptions?: AddressDisplayOptions;

  get display() {
    return Object.assign({}, defaultDisplayOptions, this.displayOptions);
  }
  get hasAddress(): boolean {
    return this.address != null;
  }

  get cityStatePostalCode(): string | undefined {
    const city = this.city != null && this.region != null ? this.city + ',' : undefined;
    const segments = [city, this.region, this.postalCode].filter((x) => x != null);
    if (segments.length === 0) {
      return undefined;
    }
    return segments.join(' ');
  }

  get streetAddress(): string | undefined {
    return this.hasAddress && getOrElse(this.display.streetAddress, false)
      ? this.address.streetAddress
      : undefined;
  }

  get city(): string | undefined {
    return this.hasAddress && getOrElse(this.display.city, false) ? this.address.city : undefined;
  }

  get region(): string | undefined {
    return this.hasAddress && getOrElse(this.display.region, false)
      ? this.address.region
      : undefined;
  }

  get postalCode(): string | undefined {
    return this.hasAddress && getOrElse(this.display.postalCode, false)
      ? this.address.postalCode
      : undefined;
  }

  get county(): string | undefined {
    return this.hasAddress && getOrElse(this.display.county, false) && this.address.county != null
      ? this.address.county.replace(/ ?(county)$/i, '') + ' County'
      : undefined;
  }

  get country(): string | undefined {
    return this.hasAddress && getOrElse(this.display.country, false)
      ? this.address.country
      : undefined;
  }

  get gpsId(): string | undefined {
    return this.hasAddress && getOrElse(this.display.gpsId, false) ? this.address.gpsId : undefined;
  }

  get coordinates(): any {
    return this.hasAddress && getOrElse(this.display.coordinates, false)
      ? this.address.coordinates
      : undefined;
  }

  constructor() {}
}
